import { TagCell, TagColor } from '@equip.health/ui';
import {
  InquiryDetailViewSurveyResponseStatusDefinition,
  NOT_CREATED,
} from '~/lib/constants/survey/SurveyResponseStatus';

interface InquiryIntakeSurveyStatusCellProps {
  inquiryId: string;
  intakeSurveyStatus: string;
}

const InquiryIntakeSurveyStatusCell = ({
  inquiryId,
  intakeSurveyStatus,
}: InquiryIntakeSurveyStatusCellProps) => {
  const { color: statusColor, label: statusLabel } =
    InquiryDetailViewSurveyResponseStatusDefinition[
      intakeSurveyStatus ?? NOT_CREATED
    ] ?? {};

  return (
    <TagCell
      color={statusColor ?? TagColor.gray}
      id={`intake-survey-status-${inquiryId}`}
      value={statusLabel}
    />
  );
};

export default InquiryIntakeSurveyStatusCell;
